<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div
                  v-if="isLoading"
                  class="alert alert-info"
                  role="status">{{$t('alerts.loading')}}....</div>
          <div
                  v-if="error"
                  class="alert alert-danger"
                  role="alert">
    <span
            class="fa fa-exclamation-triangle"
            aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMDevicePeripheralList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <EXCMDevicePeripheralForm
                    :handle-submit="onSendForm"
                    :duplicates="duplicates"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDevicePeripheralForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdeviceperipheral/create')

export default {
  components: {
    EXCMDevicePeripheralForm,
    Loader
  },

  data () {
    return {
      item: {},
      duplicates: null
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDevicePeripheralCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'EXCMDevicePeripheralList', params: { id: created['title'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      if (!this.duplicates) {
        this.getDuplicates(item)
      } else {
        this.create(item)
      }
    },

    getDuplicates (item) {
      let params = {
        'pagination': false,
        'state': 1
      }
      if (item.title) {
        params.title = item.title
      }
      this.$http.get('api/e_x_c_m_device_peripherals', {
        params
      })
        .then(response => {
          if (response.data['hydra:totalItems'] > 0) {
            this.duplicates = response.data['hydra:member']
          } else {
            this.create(item)
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
